<template>
  <div class="modal-overlay">
    <div class="modal-card">

      <div class="icon-box info-bg border-round-lg flex align-items-center justify-content-center mb-4">
        <i class="pi pi-comment text-xl info-text"></i>
      </div>

      <h2 class="text-xl font-bold mb-2 text-900">Help us improve</h2>
      <p class="text-600 mb-4 text-sm line-height-3 px-2">
        We're sorry to see you go. Could you please let us know why you're deleting your account? Your feedback helps us
        improve our services and enhance the experience for all users
      </p>

      <div class="w-full mb-5">
        <Textarea v-model="feedback" rows="5" class="w-full" placeholder="Type your feedback here...."
          :disabled="isLoading" style="resize: none;" />
      </div>

      <div class="flex justify-content-center gap-3 w-full">
        <Button label="Submit feedback" :class="buttonClass" :loading="isLoading" @click="$emit('next', feedback)" />
        <Button label="Skip and continue" :class="buttonClass" :disabled="isLoading" @click="$emit('next', null)" />
      </div>

    </div>
  </div>
</template>

<script setup>
import { ref, computed, defineEmits, defineProps } from 'vue';
import Textarea from 'primevue/textarea';
import Button from 'primevue/button';

const props = defineProps({ 
  isLoading: { type: Boolean, default: false },
  role: { type: String },
});
defineEmits(['next', 'cancel']);

const feedback = ref('');

const buttonClass = computed(() => {
  switch (props.role) {
    case 'student': return 'orange-button';
    case 'tutor': return 'teal-button';
    case 'institute': return 'yellow-button';
    default: return 'orange-button';
  }
});
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(17, 24, 39, 0.295);
  padding: 1.5rem;
  backdrop-filter: blur(3px);
}

.modal-card {
  background: white;
  width: 100%;
  max-width: 45rem;
  padding: 4rem 3rem;
  border-radius: 0.5rem;
  box-shadow: 0 4px 20px -4px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.icon-box {
  width: 3.5rem;
  height: 3.5rem;
  border: 1px solid;
}

.info-bg {
  background: #EFF6FF;
  border-color: #BFDBFE;
}

.info-text {
  color: #3B82F6;
}

@media (max-width: 640px) {
  .modal-overlay {
    padding: 1rem;
  }

  .modal-card {
    padding: 2rem 1.25rem;
  }

  .flex.justify-content-center.gap-3 {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>
